import { render, staticRenderFns } from "./faq_row.vue?vue&type=template&id=a9a4edc4&scoped=true"
import script from "./faq_row.vue?vue&type=script&lang=js"
export * from "./faq_row.vue?vue&type=script&lang=js"
import style0 from "./faq_row.vue?vue&type=style&index=0&id=a9a4edc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a4edc4",
  null
  
)

export default component.exports